var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification"},[_vm._t("default"),_c('img',{attrs:{"src":require("assets/svg/compiled/x.svg"),"alt":"Close","width":"14px"},on:{"click":function($event){return _vm.$emit('clearMessage', _vm.id)}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }